import request from "@/utils/httpRequest.js"

/**
 * @param {} data
 */
 export function fetchVipCard(params) {
  return request({
    url: 'vip-card',
    method: 'get',
    params
  })
}

export function auth(params) {
  return request({
    url: 'vip-card/auth',
    method: 'get',
    params
  })
}